import { MutableRefObject, useCallback, useRef } from 'react';
import type { GridApi, GridReadyEvent } from 'ag-grid-community';

export type OnGridReady = (event: GridReadyEvent) => void;
type Result = [MutableRefObject<GridApi | undefined>, OnGridReady];

export const useOnGridReady = (
  original?: OnGridReady,
  required?: OnGridReady,
): Result => {
  const api = useRef<GridApi | undefined>(undefined);
  const onGridReady = useCallback(
    (event: GridReadyEvent) => {
      original?.(event);
      api.current = event.api;
      required?.(event);
    },
    [original, required, api],
  );

  return [api, onGridReady];
};
